import { Loader2 } from 'lucide-react';

/**
 * Mid-page loading affordance. Keeps the literal text "Loading…" so the
 * AOZONE-31 test selector still matches.
 */
export function LoadingState() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-2 py-16 text-sm text-slate-500"
    >
      <Loader2 className="h-4 w-4 animate-spin" />
      <span>Loading…</span>
    </div>
  );
}
